export default function NoSubmissionsIllustration() {
  return (
    <svg className="illustration" width="72" height="72" viewBox="0 0 72 72" fill="none">
      <rect x="16" y="14" width="34" height="44" rx="4" fill="var(--accent-bg)" stroke="var(--accent)" strokeWidth="1.5" />
      <rect x="24" y="24" width="18" height="3" rx="1.5" fill="var(--accent)" opacity="0.5" />
      <rect x="24" y="32" width="18" height="3" rx="1.5" fill="var(--accent)" opacity="0.35" />
      <rect x="24" y="40" width="12" height="3" rx="1.5" fill="var(--accent)" opacity="0.25" />
      <circle cx="52" cy="20" r="7" fill="var(--brand-red-bg)" stroke="var(--brand-red)" strokeWidth="1.5" />
      <path d="M52 17v6M49 20h6" stroke="var(--brand-red)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
